import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import {useQuery} from '@apollo/client';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {GetCountries} from '@graphql/country/query';
import {CountriesFilter} from '@utils/commonFilters/CountriesFilter';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {ArchivedFilter} from '@utils/commonFilters/ArchivedFilter';

import {showErrorNotificationMessage} from '../utils/blackoutZone';

export const BlackoutZoneFilters = ({
    restoreFilterValues,
    filters,
    loading: loadingFilters,
}) => {
    const {
        data: {
            countries,
        } = {},
        error: errorFetchingCountriesData,
        loading: isCountriesLoading = true,
    } = useQuery(GetCountries);

    useMemo(()=> {
        errorFetchingCountriesData && showErrorNotificationMessage();
    }, [errorFetchingCountriesData]);

    const loading = isCountriesLoading || loadingFilters;

    return (
        <div className='content__filters'>
            <SearchFilter
                loading={loading}
                filters={filters.BlackoutZone}
                restoreFilterValues={restoreFilterValues}
            />
            <CountriesFilter
                countries={countries}
                loading={loading}
                filters={filters.BlackoutZone}
                restoreFilterValues={restoreFilterValues}
            />
            <ArchivedFilter
                loading={loading}
                filters={filters}
                filterKey='BlackoutZone'
                restoreFilterValues={restoreFilterValues}
            />
        </div>
    );
};

BlackoutZoneFilters.propTypes = {
    filters: PropTypes.shape({
        BlackoutZone: PropTypes.object.isRequired,
    }),
    loading: PropTypes.bool,
    restoreFilterValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(BlackoutZoneFilters, {name: 'BlackoutZone', initialValues: {isArchived: 0}});
